/**
 *
 * environment selector module for eBay
 *
 */
'use strict';

module.exports = {
    _env: function () {
        return process.env.DEPLOY_ENV;
    },
    isLocalDebug: function() {
        return process.env.DEBUG_ON_DEV_MACHINE === 'true';
    },
    isDev: function () {
        return !!(this._env() &&
            (/dev/i).test(this._env())) || !this._env();
    },
    isNotDev: function () {
        return !this.isDev();
    },
    isTest: function () {
        return !!(this._env() &&
            (/test/i).test(this._env()));
    },
    isNotTest: function () {
        return !this.isTest();
    },
    isStage: function () {
        return !!(this._env() &&
            ((/stag/i).test(this._env()) || (/qa/i).test(this._env())) || (/feature/i).test(this._env()));
    },
    isQA: function () {
        return this.isStage();
    },
    isNotStage: function () {
        return !this.isStage();
    },
    isNotQA: function () {
        return this.isNotStage();
    },
    isSandbox: function () {
        return !!(this._env() &&
            (/sandbox/i).test(this._env()));
    },
    isNotSandbox: function () {
        return !this.isSandbox();
    },
    isLnp: function () {
        return !!(this._env() &&
            (/lnp/i).test(this._env()));
    },
    isNotLnp: function () {
        return !this.isLnp();
    },
    isPreProd: function () {
        return !!(this._env() &&
            (/pre-prod/i).test(this._env()));
    },
    isNotPreProd: function () {
        return !this.isPreProd();
    },
    isProd: function () {
        return !!(this._env() &&
            ((/live/i).test(this._env()) || (/secure/i).test(this._env()) || (/^prod/i).test(this._env())));
    },
    isLive: function () {
        return this.isProd();
    },
    isNotProd: function () {
        return !this.isProd();
    },
    isNotLive: function () {
        return this.isNotProd();
    },
    isSecure: function () {
        return !!(this._env() &&
            ((/secure/i).test(this._env())));
    }
};
